import React from 'react';
import { Avatar, Box, Card, CardContent, Typography } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';

type DisplayDossierProcessBlocForm = {
    id: number;
    label: string;
    checked: boolean;
};

export type DisplayDossierProcessesBlocFormProps = {
    items: Array<DisplayDossierProcessBlocForm>;
    onToggleItem: (id: number) => void;
};

const DisplayDossierProcessesBlocForm: React.FunctionComponent<DisplayDossierProcessesBlocFormProps> =
    function (props) {
        const { items, onToggleItem } = props;

        return (
            <Box sx={{ minWidth: '500px' }}>
                <Box sx={{ marginBottom: '16px' }}>
                    <Typography variant="l2dh6">Ajouter une démarche</Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flexWrap: 'wrap',
                            rowGap: '1em',
                            paddingTop: '16px',
                        }}
                    >
                        {items.map((item) => (
                            <Card
                                key={item.label}
                                variant="outlined"
                                sx={{
                                    margin: 0,
                                    cursor: 'pointer',
                                    bgcolor: item.checked ? 'primary.50' : 'background.paper',
                                    border: item.checked ? 2 : 1,
                                    borderColor: item.checked ? `primary.main` : 'divider',
                                    '&:hover': { boxShadow: 2 },
                                }}
                                onClick={() => onToggleItem(item.id)}
                            >
                                <CardContent
                                    sx={{ paddingTop: 0, paddingBottom: '0px !important' }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <Avatar
                                            sx={{
                                                backgroundColor: `primary.light`,
                                            }}
                                        >
                                            <FaOptionIcon
                                                icon={['fasl', 'building-columns']}
                                                sx={{
                                                    color: `primary.dark`,
                                                    fontSize: '16px',
                                                }}
                                            />
                                        </Avatar>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '0.5em',
                                                alignItems: 'flex-start',
                                                flexGrow: 1,
                                            }}
                                        >
                                            <Typography
                                                variant="l2dh7"
                                                fontWeight="500"
                                            >
                                                {item.label}
                                            </Typography>
                                        </Box>
                                        {item.checked && (
                                            <FaOptionIcon
                                                icon={['fasl', 'check']}
                                                sx={{ color: `primary.main` }}
                                            />
                                        )}
                                    </Box>
                                </CardContent>
                            </Card>
                        ))}
                    </Box>
                </Box>
            </Box>
        );
    };

export default DisplayDossierProcessesBlocForm;
